import { CompanyCardSettings } from '../modules/finance/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
export function CompanyCardSettingsScreen() {
  const { can, company } = useCompanyScope();
  const unit = company.businessUnits?.find((item) => item.id === company.activeBusinessUnitId);
  return (
    <GatedCompanyScreen allowed={can('financial_cards.settings.manage')}>
      <CompanyCardSettings
        key={unit?.id ?? 'company'}
        unitName={unit?.displayName ?? null}
        unitId={unit?.id ?? null}
      />
    </GatedCompanyScreen>
  );
}
